// localStorage key for the language picked in the header, restored when the app starts
export const LANG_STORAGE_KEY = 'itrace.lang';
